import { ROLES } from "../consts";
import { createAPI } from "./utils.firebase";

export const UsersAPI = createAPI('usuarios')
export const RequestsAPI = createAPI("Solicitudes")
export const AssignmentsAPI = createAPI("asignaciones")
export const ClientsAPI = createAPI('usuarios').where('role', '==', ROLES.CLIENT)
export const ExpertsAPI = createAPI('usuarios').where('role', '==', ROLES.EXPERT_CLIENT)
export const ExpertAdmins = createAPI('usuarios').where('role', '==', ROLES.EXPERT_ADMIN)
